import { Component, HostListener, NgZone } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { gsap } from 'gsap';
@Component({
  selector: 'app-home-component',
  templateUrl: './home-component.component.html',
  styleUrls: ['./home-component.component.css']
})
export class HomeComponentComponent {
  screenWidth: any;
  screenHeight: any;
  scheduleButton: HTMLElement | null = null; // Initialize to null
  trialButton: HTMLElement | null = null; // Initialize to null
  constructor(private ngZone: NgZone, private titleService: Title, private metaService: Meta) {
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    };
  }
  ngOnInit(): void {
    this.titleService.setTitle('Home');
    this.metaService.updateTag({ name: 'description', content: 'Welcome to Sharkify.ai, your partner in digital marketing!' });
    gsap.from('.animate', { duration: 1, opacity: 0, y: -50 });
    // Add event listeners for buttons
    this.scheduleButton = document.querySelector(".schedule-btn");
    this.trialButton = document.querySelector(".trial-btn");
    this.scheduleButton?.addEventListener("click", () => {
      alert("Schedule a post feature is coming soon!");
    });
    // this.trialButton?.addEventListener("click", () => {
    //   alert("Enjoy your 7-day free trial!");
    // });
    // Typing animation setup
    const typingIndicator1 = document.getElementById("dot1") as HTMLElement;
    const typingIndicator2 = document.getElementById("dot2") as HTMLElement;
    const message1 = document.querySelectorAll(".message")[0] as HTMLElement;
    const message2 = document.querySelectorAll(".message")[1] as HTMLElement;
    const icon1 = message1.querySelector(".icon") as HTMLElement;
    const icon2 = message2.querySelector(".icon") as HTMLElement;
    const text1 = document.querySelectorAll(".message .text")[0] as HTMLElement;
    const text2 = document.querySelectorAll(".message .text")[1] as HTMLElement;
    function startTypingAnimation(ti: HTMLElement, delay: number, onComplete?: () => void) {
      const spans = ti.querySelectorAll('span');
      return gsap.to(spans, {
        opacity: 1,
        duration: 0.3,
        stagger: 0.2,
        delay: delay / 30000, // Convert delay to seconds
        onComplete: onComplete
      });
    }
    function revealTextOneByOne(textDiv: HTMLElement, onComplete?: () => void) {
      const text = textDiv.textContent || "";
      textDiv.textContent = "";
      const chars = text.split("");
      chars.forEach((char, index) => {
        const span = document.createElement("span");
        span.textContent = char;
        span.style.opacity = '0';
        textDiv.appendChild(span);
        gsap.to(span, {
          opacity: 1,
          duration: 0.1,
          delay: index * 0.1,
          onComplete: () => {
            if (index === chars.length - 1 && onComplete) {
              gsap.to(textDiv.previousElementSibling, { opacity: 0, duration: 0.5 }); // Hide typing indicator
              onComplete();
            }
          }
        });
      });
    }
    // Keep the text and message boxes hidden initially
    message1.style.opacity = '0';
    message2.style.opacity = '0';
    text1.setAttribute("hidden", "");
    text2.setAttribute("hidden", "");
    // Animate the first icon, message box, and typing animation
    gsap.to(icon1, {
      opacity: 1,
      duration: 1,
      delay: 0.5,
      onComplete: () => {
        gsap.to(message1, {
          opacity: 1,
          duration: 1,
          onComplete: () => {
            const animation1 = startTypingAnimation(typingIndicator1, 1000, () => {
              text1.removeAttribute("hidden");
              typingIndicator1.innerHTML = "";
              revealTextOneByOne(text1, () => {
                animation1.kill(); // Stop the typing animation
                // Animate the second icon, message box, and typing animation after the first text appears
                gsap.to(icon2, {
                  opacity: 1,
                  duration: 1,
                  delay: 0.5,
                  onComplete: () => {
                    gsap.to(message2, {
                      opacity: 1,
                      duration: 1,
                      onComplete: () => {
                        const animation2 = startTypingAnimation(typingIndicator2, 1000, () => {
                          text2.removeAttribute("hidden");
                          typingIndicator2.innerHTML = "";
                          revealTextOneByOne(text2, () => {
                            animation2.kill(); // Stop the typing animation
                            gsap.to(typingIndicator2, { opacity: 0, duration: 0.5 }); // Hide typing indicator
                          });
                        });
                      }
                    });
                  }
                });
              });
            });
          }
        });
      }
    });
  }
  @HostListener('window:scroll', [])
  scrollTo(sectionId: string) {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 50);
    });
  }
}






